// this is an autogenerated file from App/Account/Content/Tasks/New/TaskOverlay/Content/mutation-update-resource.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_TaskOverlay_Content($resource_id: uuid!, $document_id: uuid!) {
  update_tasks_resources_by_pk(
    pk_columns: { id: $resource_id }
    _set: { document_id: $document_id }
  ) {
    id
  }
}

`